
export const Environment = {
  
  LIMITE_DE_LINHAS: 8,
 
  INPUT_DE_BUSCA: 'Pesquisar...',
 
  LISTAGEM_VAZIA: 'Nenhum registro encontrado.',

  URL_BASE: process.env.REACT_APP_URL_BASE,
  URL_IMGUSUARIOS: process.env.REACT_APP_URL_IMGUSUARIOS,
  URL_IMGFABRICA: process.env.REACT_APP_URL_IMGFABRICAS,

  COR_RELATORIOS: '#40481E',

  COR_RELATORIOS_TEXTO: '#000000'

};



